import React from 'react';
import PropTypes from 'prop-types';

import DomainManagementBulkDomainsError from './domain-management-bulk-domains-error';

const DomainManagementBulkErrors = ( { classes, domainActionType, domainErrors } ) => {
    return (
        <>
            {
                Object.keys( domainErrors ).map(
                    domainErrorType => {
                        return (
                            <DomainManagementBulkDomainsError
                                key={domainErrorType}
                                domainActionType={domainActionType}
                                domainList={domainErrors[domainErrorType]}
                                errorType={domainErrorType} />
                        );
                    }
                )
            }
        </>
    );
};

DomainManagementBulkErrors.propTypes = {
    classes: PropTypes.object,
    domainActionType: PropTypes.string,
    domainErrors: PropTypes.object.isRequired,
};

export default DomainManagementBulkErrors;
